import classNames from 'classnames';
import React, { Component } from 'react';
import { s as styleInject } from './style-inject.es-e7b07dd7.js';

var css_248z = ".glob_fontElementMap,.oaUmg{font-family:var(--ricos-font-family,unset)}.yOljL{color:var(--ricos-custom-p-color,unset);color:var(--ricos-custom-p-color,var(--ricos-text-color,#212121));line-height:21px;font:inherit;font-family:var(--ricos-custom-p-font-family,unset);font-size:var(--ricos-custom-p-font-size,unset);font-size:14px;font-style:var(--ricos-custom-p-font-style,unset);font-weight:var(--ricos-custom-p-font-weight,unset);line-height:var(--ricos-custom-p-line-height,unset);min-height:var(--ricos-custom-p-min-height,unset);position:inherit;resize:none;text-decoration:var(--ricos-custom-p-text-decoration,unset);width:100%;z-index:1}[dir] .yOljL{border:none}[dir] .yOljL>span>span,[dir] span>a span{background-color:var(--ricos-custom-p-background-color,unset)}@supports not (contain:inline-size){@media only screen and (max-width:640px){.yOljL{font-size:var(--ricos-custom-p-font-size,unset)}}}@container (width < 640px){.yOljL{font-size:var(--ricos-custom-p-font-size,unset)}}[dir] .yOljL[readonly]{cursor:pointer}";
var styles = {"fontElementMap":"oaUmg","inPluginInput":"yOljL"};
styleInject(css_248z);

class InPluginInput extends Component {
  constructor() {
    super(...arguments);
    this.handleFocus = (e) => {
      e.stopPropagation();
      this.props.setFocusToBlock();
      this.props.setInPluginEditingMode(true);
    };
    this.handleBlur = () => this.props.setInPluginEditingMode(false);
    this.handleKeyPress = (e) => {
      const { setFocusToBlock, value } = this.props;
      if (e.key === "Enter" && setFocusToBlock && value !== "") {
        this.handleBlur();
        setFocusToBlock();
      }
    };
    this.onChange = (e) => {
      var _a, _b;
      return (_b = (_a = this.props).onChange) == null ? void 0 : _b.call(_a, e.target.value);
    };
  }
  render() {
    const className = classNames(styles.inPluginInput, this.props.className);
    return /* @__PURE__ */ React.createElement(
      "textarea",
      {
        className,
        value: this.props.value,
        onChange: this.onChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: this.handleKeyPress,
        dir: "auto",
        rows: 1
      }
    );
  }
}
InPluginInput.defaultProps = {
  setInPluginEditingMode: () => false,
  setFocusToBlock: () => false
};

export { InPluginInput as default };
//# sourceMappingURL=InPluginInput.js.map
